import React, {useCallback, useState} from 'react';
import EventCard from './event-card';
import {DialogContent, Grid, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {EventData} from '@/types/event';
import EventDetailsDialog from './details';
import DialogWithCloseIcon from '@/components/ui/dialogs/dialog-with-close-icon';
import {MatrixRoomProvider} from '@/contexts/matrix/room/provider';

const EVENT_CARD_HEIGHT = '100';
interface AllEventsDialogProps {
  events: EventData[];
  onClose: () => void;
  allEventsDialogOpen: boolean;
  onChange?: (data: EventData) => void;
  onDelete?: (eventId: string) => void;
  onClone?: () => void;
  onCloseGroupDetails?: () => void;
}

const AllEventsDialog: React.FC<AllEventsDialogProps> = ({
  events,
  onClose,
  allEventsDialogOpen,
  onChange,
  onDelete,
  onClone,
  onCloseGroupDetails
}) => {
  const {t} = useTranslation();

  const [selectedEvent, setSelectedEvent] = useState<EventData | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const onEventCardClick = useCallback((event: EventData) => {
    setSelectedEvent(event);
    setDialogOpen(true);
  }, []);

  const handleCloseEventDetails = useCallback(() => {
    setDialogOpen(false);
    setSelectedEvent(null);
  }, []);

  return (
    <DialogWithCloseIcon
      open={allEventsDialogOpen}
      onClose={() => {
        onClose();
      }}
      fullWidth={true}
      maxWidth="lg"
    >
      <>
        <Typography variant="h5" component="div" align="center">
          {t('allEvents')}
        </Typography>
        <DialogContent>
          <Grid container spacing={1}>
            {events.map((event: EventData) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={4} key={event._id}>
                  <EventCard
                    key={event._id}
                    event={event}
                    onEventCardClick={onEventCardClick}
                    fullWidth={true}
                    cardMediaHeight={EVENT_CARD_HEIGHT}
                    smallerVariant={true}
                  />
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>

        {selectedEvent && (
          <MatrixRoomProvider childId={selectedEvent._id}>
            <EventDetailsDialog
              onChange={onChange}
              onDelete={onDelete}
              onClone={onClone}
              open={dialogOpen}
              onClose={handleCloseEventDetails}
              event={selectedEvent}
              myGroupAsDefaultInCloneForm={true}
              onCloseGroupDetails={onCloseGroupDetails}
            />
          </MatrixRoomProvider>
        )}
      </>
    </DialogWithCloseIcon>
  );
};

export default AllEventsDialog;
